// PropertyDetailsForm.jsx

import React from 'react';
import { Grid, TextField, FormControl } from '@mui/material';
import Select from 'react-select';
import { UploadPropertyPageStyles, selectStyles } from './UploadPropertyPage.styles';

const PropertyDetailsForm = ({
  address,
  setAddress,
  city,
  setCity,
  state,
  setState,
  zip,
  setZip,
  description,
  setDescription,
  // Hidden until PMS integration:
  // propertyType,
  // setPropertyType,
  // rent,
  // setRent,
  // deposit,
  // setDeposit,
  // applicationFee,
  // setApplicationFee,
  // qualifyingCriteria,
  // setQualifyingCriteria,
  listingLink,
  setListingLink,
  applicationLink,
  setApplicationLink,
  schedulingRestrictions,
  setSchedulingRestrictions,
  specialInstructions,
  setSpecialInstructions,
  stateOptions,
  cityOptions,
  agentPhone,
  setAgentPhone,
}) => {

  // Function to format address into a standardized format
  return (
    <>
      {/* Street Address Input */}
      <Grid item xs={12}>
        <TextField
          label="Street Address"
          fullWidth
          required
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          sx={UploadPropertyPageStyles.textField}
        />
      </Grid>

      {/* State Dropdown */}
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <Select
            options={stateOptions}
            value={state}
            onChange={(selectedOption) => {
              setState(selectedOption);
              setCity(null); // Reset city when state changes
            }}
            placeholder="Select State"
            styles={selectStyles}
          />
        </FormControl>
      </Grid>

      {/* City Dropdown */}
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <Select
            options={cityOptions}
            value={city}
            onChange={(selectedOption) => setCity(selectedOption)}
            placeholder="Select City"
            isDisabled={!state} // Disable if state isn't selected
            styles={selectStyles}
          />
        </FormControl>
      </Grid>

      {/* ZIP Code Input */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="ZIP Code"
          fullWidth
          required
          value={zip}
          onChange={(e) => {
            // Only allow 5 digit numbers
            if (/^\d{0,5}$/.test(e.target.value)) setZip(e.target.value);
          }}
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]{5}",
            maxLength: 5,
          }}
          helperText="ZIP code must be 5 digits."
          sx={UploadPropertyPageStyles.textField}
        />
      </Grid>

      {/* Description */}
      <Grid item xs={12}>
        <TextField
          label="Description"
          fullWidth
          required
          multiline
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={UploadPropertyPageStyles.textField}
        />
      </Grid>

      {/* 
        Hidden until PMS integration (Appfolio, Buildium, Rentec, Rentvine, Yardi, etc):
        - Property Type
        - Rent Amount
        - Deposit Amount
        - Application Fee
        - Qualifying Criteria
      */}

      {/* Listing Link - link to the property on their PMS or listing site */}
      <Grid item xs={12}>
        <TextField
          label="Listing Link"
          fullWidth
          placeholder="Link to your property listing (e.g., Zillow, Apartments.com, etc.)"
          value={listingLink}
          onChange={(e) => setListingLink(e.target.value)}
          helperText="Enter a link to the full listing with rent, deposit, and other details"
        />
      </Grid>

      {/* Rental Application Link */}
      <Grid item xs={12}>
        <TextField
          label="Rental Application Link"
          fullWidth
          value={applicationLink}
          onChange={(e) => setApplicationLink(e.target.value)}
        />
      </Grid>

      {/* Scheduling Restrictions */}
      <Grid item xs={12}>
        <TextField
          label="Scheduling Restrictions"
          fullWidth
          multiline
          rows={3}
          value={schedulingRestrictions}
          onChange={(e) => setSchedulingRestrictions(e.target.value)}
          sx={UploadPropertyPageStyles.textField}
        />
      </Grid>

      {/* Special Instructions */}
      <Grid item xs={12}>
        <TextField
          label="Special Instructions"
          fullWidth
          multiline
          rows={3}
          value={specialInstructions}
          onChange={(e) => setSpecialInstructions(e.target.value)}
          sx={UploadPropertyPageStyles.textField}
        />
      </Grid>
      {/* Agent phone */}
      <Grid item xs={12}>
        <TextField
          label="Agent Phone Number"
          fullWidth
          value={agentPhone}
          onChange={(e) => {
            // Strip all non-digit characters
            const digits = e.target.value.replace(/\D/g, '');
            // Limit to 10 digits
            const limitedDigits = digits.slice(0, 10);
            // Auto-format as XXX-XXX-XXXX
            let formatted = '';
            if (limitedDigits.length > 0) {
              formatted = limitedDigits.slice(0, 3);
            }
            if (limitedDigits.length > 3) {
              formatted += '-' + limitedDigits.slice(3, 6);
            }
            if (limitedDigits.length > 6) {
              formatted += '-' + limitedDigits.slice(6, 10);
            }
            setAgentPhone(formatted);
          }}
          sx={UploadPropertyPageStyles.textField}
          inputProps={{
            inputMode: "tel",
            maxLength: 12, // XXX-XXX-XXXX = 12 chars
          }}
          placeholder="(555) 123-4567"
          helperText="Enter 10-digit phone number"
        />
      </Grid>
    </>
  );
};

export default PropertyDetailsForm;

